import { Component, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { PermissionService } from 'src/app/services/permission.service';
import Tooltip from 'bootstrap/js/dist/tooltip';

@Component({
  selector: 'app-trailer-actions',
  templateUrl: './trailer-actions.component.html',
  styleUrls: ['./trailer-actions.component.css']
})
export class TrailerActionsComponent implements AfterViewInit, OnDestroy {
  private tooltips: any[] = [];

  constructor(private permissionService: PermissionService, private el: ElementRef<HTMLElement>) { }

  public cellValue!: any;

  agInit(params: ICellRendererParams): void {
    this.cellValue = params;
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = params;
    return true;
  }

  ngAfterViewInit(): void {
    const tooltipTriggerList = Array.from(
      this.el.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]')
    ) as HTMLElement[];
    this.tooltips = tooltipTriggerList.map(el => new Tooltip(el));
  }

  ngOnDestroy(): void {
    this.tooltips.forEach(t => t.dispose());
    this.tooltips = [];
  }

  canDo(action: string) {
    const module = this.cellValue?.module || 'Remolques';
    return this.permissionService.canDo(module, action);
  }

  deleteEvent() {
    this.cellValue.parent.actionDelete(this.cellValue.data.id);
  }
}
